module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("du5YD"))).then(() => parcelRequire('f4eak'));